import { Injectable } from '@angular/core';

import { GraphQLService } from '@app/services';
import { 
    mutationQuestionRespond
} from '@app/graphql-queries';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
    
    constructor(
        private graphQLService: GraphQLService
    ) { }
    
    async sendAnswer(questionID: string, answer: string): Promise<boolean> {
        let status: boolean = false;
        let response = await this.graphQLService.mutate({   
            mutation: mutationQuestionRespond,
            variables: {                
                ID: questionID,
                params: JSON.stringify({               
                    response: answer
                }),
            }       
        });     
        if(response?.data?.QuestionPostResponse){
            status = true;
        }
        return status;
    }
    
}
